import React, { useRef } from 'react';
import { FaPrint, FaTimes } from 'react-icons/fa';
import { usePDF } from 'react-to-pdf';

// import '../../assets/css/printableLabReport.css'; // Ensure this CSS is included

const PreviewModal = ({ data, closeModal }) => {

    const { toPDF, targetRef } = usePDF({ filename: 'lab request.pdf' });

    const {
        dateOfVisit, temperature, age, weight, diagnosis, additonalNote, otherPrescriptions, treatmentStatus, isAdmitted, carePlan, prescriptions
    } = data;

    const administrationFrequencies = [
        { id: 1, name: 'Immediately' },
        { id: 2, name: 'As needed' },
        { id: 3, name: 'Once daily' },
        { id: 4, name: 'Twice a day' },
        { id: 5, name: 'Three times a day' },
        { id: 6, name: 'Four times a day' },
        { id: 7, name: 'At night' },
        { id: 8, name: 'Morning' },
        { id: 9, name: 'Evening' },
        { id: 10, name: 'Every 24 hours' },
        { id: 11, name: 'Every 12 hours' },
        { id: 12, name: 'Every 8 hours' },
        { id: 13, name: 'Every 6 hours' },
        { id: 14, name: 'Every 4 hours' },
        { id: 15, name: 'Every 3 hours' },
        { id: 16, name: 'Every 2 hours' },
        { id: 17, name: 'Every hour' },
        { id: 18, name: 'Every 2 months' },
        { id: 19, name: 'Every 3 months' },
    ];

    const drugStrengthUnits = [
        { id: 0, name: "Milligrams" },
        { id: 1, name: "Grams" },
        { id: 2, name: "Micrograms" },
        { id: 3, name: "Milliliters" },
        { id: 4, name: "Liters" },
        { id: 5, name: "Units" },
        { id: 6, name: "Puffs" },
        { id: 7, name: "Sprays" },
        { id: 8, name: "Drops" },
        { id: 9, name: "Patch" },
        { id: 10, name: "Bottle" },
        { id: 11, name: "TransdermalSystem" },
        { id: 12, name: "Tablet" },
        { id: 13, name: "Capsule" },
        { id: 14, name: "Suppository" },
        { id: 15, name: "Scoop" },
        { id: 16, name: "Sachet" },
        { id: 17, name: "Ampoule" },
        { id: 18, name: "Vial" },
        { id: 19, name: "InjectionPen" },
        { id: 20, name: "Enema" },
        { id: 21, name: "Ounces" },
        { id: 22, name: "Teaspoon" },
        { id: 23, name: "Tablespoon" },
        { id: 24, name: "Milliequivalents" },
        { id: 25, name: "InternationalUnits" }
    ];


    const routesOfAdministration = [
        { id: 1, name: 'Orally' },
        { id: 2, name: 'Sublingual' },
        { id: 3, name: 'Topical' },
        { id: 4, name: 'Inhalation' },
        { id: 5, name: 'Suppository' },
        { id: 6, name: 'IV' },
        { id: 7, name: 'IM' },
        { id: 8, name: 'Subcut' },
        { id: 9, name: 'Intradermal' },
        { id: 10, name: 'PerRectum' },
        { id: 11, name: 'PerVagina' },
        { id: 12, name: 'Implant' },
    ];

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                {/* <button className="close-modal" onClick={closeModal}><FaTimes /></button> */}
                <div className="print-container p-20" ref={targetRef}>
                    {/* <h1 className='center-text m-b-20'>
                        HEARTLAND CARDIOVASCULAR
                    </h1> */}
                    <div className="report-header">

                        <div className="patient-info">
                            <h1>Patient Pharmaceutical Report</h1>
                            <p><strong>Date of Visit:</strong> {new Date(dateOfVisit).toDateString()}</p>
                        </div>
                    </div>

                    <section className="details-section">
                        <h2>Patient Details</h2>
                        <p><strong>Age:</strong> {age}</p>
                        <p><strong>Temperature:</strong> {temperature}°F</p>
                        <p><strong>Weight:</strong> {weight} kg</p>
                        {/* <p><strong>Admitted:</strong> {isAdmitted ? 'Yes' : 'No'}</p> */}
                    </section>

                    <section className="medical-info">
                        <h2>Medical Details</h2>
                        <p><strong>Diagnosis:</strong> {diagnosis}</p>
                        {additonalNote && <p><strong>Additional Note:</strong> {additonalNote}</p>}
                        <p><strong>Care Plan:</strong> {carePlan}</p>
                    </section>

                    <section className="prescriptions">
                        <h2>Prescriptions</h2>
                        {prescriptions && prescriptions.length > 0 ? (
                            <ul>
                                {prescriptions.map((prescription, index) => (
                                    <li key={index}>
                                        <strong>{prescription.pharmacyInventory.productName}</strong> 
                                        <br />
                                        {prescription.dosage
                                            ? <>Dosage: {prescription.dosage}</>
                                            : <>Dosage: {prescription.quantity} units, {prescription.frequency} times per day for {prescription.duration} days</>
                                        }
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No prescriptions provided.</p>
                        )}
                    </section>

                    <section className="other-prescriptions">
                        <h2>Other Prescriptions</h2>
                        {otherPrescriptions && otherPrescriptions.length > 0 ? (
                            <ul>
                                {otherPrescriptions.map((prescription, index) => (
                                    <li key={index}>
                                        <strong>{prescription.name}</strong>
                                        <p>
                                            Dosage: {prescription.quantity} units, {prescription.frequency} times per day for {prescription.duration} days
                                        </p>

                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No other prescriptions provided.</p>
                        )}
                    </section>
                </div>

                <div className="print-buttons">
                    <button className="print-btn" onClick={() => toPDF()}><FaPrint /> Print</button>
                    <button className="close-btn" onClick={closeModal}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default PreviewModal;
